import { Fetcher } from '@this/src/util';

// ホテル検索結果画面の操作計測（タブ選択 / 宿選択 / 地図利用）をサーバーに記録するモジュール。
// 計測の失敗が検索・予約フローを止めないよう、送信は fire-and-forget でエラーは握りつぶす。

export type HotelSearchEventType = 'tab_select' | 'item_select';
export type HotelSearchEventTargetType = 'recommended' | 'price' | 'distance' | 'station_distance' | 'map';

type SortKey = 'orderedIndex' | 'average_price_with_tax' | 'distance' | 'station_distance' | 'map';

export const sortKeyToEventTargetType = (sortKey: SortKey): HotelSearchEventTargetType => {
  switch (sortKey) {
    case 'average_price_with_tax':
      return 'price';
    case 'distance':
      return 'distance';
    case 'station_distance':
      return 'station_distance';
    case 'map':
      return 'map';
    case 'orderedIndex':
    default:
      return 'recommended';
  }
};

interface RecordParams {
  searchQueryItemId: number;
  eventType: HotelSearchEventType;
  eventTargetType: HotelSearchEventTargetType;
  displayIndex?: number | null;
  searchResultId?: string | null;
}

export const recordHotelSearchInteractionEvent = (params: RecordParams): void => {
  Fetcher.post('/hotel_search_interaction_events', {
    hotel_search_interaction_event: {
      search_query_item_id: params.searchQueryItemId,
      event_type: params.eventType,
      event_target_type: params.eventTargetType,
      display_index: params.displayIndex,
      search_result_id: params.searchResultId
    }
  }).catch(error => {
    // 計測失敗は検索・予約フローを止めない。原因追跡用にログだけ残す。
    console.warn('[HotelSearchInteractionEvent] 計測の送信に失敗:', error);
  });
};
